import { Alert, Box, Container, Snackbar, SnackbarCloseReason, Typography } from "@mui/material";
import React, { useEffect } from "react";

const ErrorPage: React.FC = () => {

  const imagePath = "/assets/images/success.svg";

  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    showToast();
  }, [])
  

  const showToast = () => {
    setOpen(true);
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <Container sx={{
      height: "100%",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          {"Consent has been approved successfully"}
        </Alert>
      </Snackbar>

      <Box>
        <Box textAlign={"center"}>
          <img src={imagePath} alt="Dynamic Icon" width={200} height={200} />
        </Box>
        <Box textAlign={"center"}>
          <Typography mt={5} variant="h4">Consent has been approved!!!</Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default ErrorPage;
